module.exports = __webpack_public_path__ + "img/여준호.a2fe0229.jpg";